import * as React from "react";
import clsx from "clsx";
import { Icon } from "../icon/icon/icon.mjs";
const TooltipToggle = React.forwardRef(function TooltipToggle2(props, ref) {
  const { children, id, className, icon, color, onClick, ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      ...rest,
      className: clsx(
        "tooltip-toggle",
        {
          ["tooltip-toggle--icon"]: !!icon,
          ["tooltip-toggle--".concat(color)]: !!color
        },
        className
      ),
      type: "button",
      id,
      ref,
      onClick: (e) => {
        e.stopPropagation();
        onClick == null ? void 0 : onClick(e);
      }
    },
    /* @__PURE__ */ React.createElement("span", { className: "tooltip-toggle__inner" }, /* @__PURE__ */ React.createElement("span", { className: "tooltip-toggle__text" }, children), icon && /* @__PURE__ */ React.createElement(Icon, { modifiers: "#help", className: "tooltip-toggle__icon", size: "xs" }))
  );
});
export {
  TooltipToggle
};
